<template>
  <div class="bg-white text-left py-6 px-12">
    <div class="border-b-1 border-hex-E4E4E4">
      <div class="flex space-x-3">
        <p class="text-lg">{{ $t("选择支付方式") }}</p>

        <p
          class="bg-main w-8rem text-0.75rem flex-center text-white space-x-1"
          @click="addCard"
        >
          <span class="iconfont icon-tianjia"></span>
          <span>{{ $t("去添加银行卡") }}</span>
        </p>
      </div>
      <div class="space-y-4 py-8">
        <el-radio-group v-model="radio" class="space-y-6">
          <el-radio
            v-for="item in moneyPayTypes"
            :key="item.id"
            :label="item.id"
          >
            <img :src="item.logo" class="w-1.65rem h-1.65rem" />
            <span class="text-dark-100">{{ item.name }}</span>
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="pt-6 space-y-2">
      <p>
        {{ $t("充值") }}：
        <span class="text-hex-F89600 text-xl">￥{{ payMoney }}</span>
      </p>
      <p class="text-0.75rem text-hex-909090 pb-5">
        {{ $t("免服务费，预计次日到账") }}
      </p>
      <el-button type="warning" class="text-1rem" @click="confirm">{{
        $t("确认支付")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "@vue/composition-api";

export default {
  setup(props, ctx) {
    const radio = ref(Number(1));
    const checked = ref(true);
    const addCard = () => {
      ctx.root.$router.push({
        name: "addCard",
      });
    };
    // const card_message = ref()
    // const cardLength = computed(() => (card_message?.value?.length ? card_message.value.length : 0))
    const payMoney = ref();
    //可选择支付方式
    const moneyPayTypes = ref();
    onMounted(async () => {
      payMoney.value = ctx.root.$route.query.payMoney;
      moneyPayTypes.value = (
        await ctx.root.$callapi("pay/getMoneyPayTypes", {
          money: payMoney.value,
          payfor: "recharge",
        })
      ).data.types;
    });

    //确认支付
    const confirm = async () => {
      ctx.root.$doing();
      await ctx.root
        .$callapi("pay/payRequest", {
          balance: false,
          datajson: "{}",
          money: payMoney.value,
          payfor: "recharge",
          title: "充值",
        })
        .then(async (res) => {
          ctx.root.$done();
          if (res.code == 0) {
            ctx.root.$doing();
            await ctx.root
              .$callapi("pay/readyPay", {
                kwargs: {},
                poid: res.data.id,
                ptid: 1,
              })
              .then(async (res) => {
                ctx.root.$done();
                if (res.code == 0) {
                  ctx.root.$doing();
                  await ctx.root
                    .$callapi("pay/checkPayResult", {
                      poid: res.data.po.id,
                    })
                    .then(async () => {
                      ctx.root.$done();
                      if (res.code == 0) {
                        await ctx.root.$router.push({
                          name: "Wallet",
                        });
                        await ctx.root.$toast(
                          ctx.root.$t("申请提交成功"),
                          "success"
                        );
                      }
                    });
                }
              });
          }
        });
      ctx.root.$done();
    };
    return { radio, checked, addCard, payMoney, moneyPayTypes, confirm };
  },
};
</script>
<style scoped lang="scss">.el-radio-group ::v-deep .el-radio {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.el-radio ::v-deep span {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.el-radio ::v-deep span > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}</style>
